import { Component, ErrorInfo, ReactNode } from 'react'

type RecipeErrorBoundaryProps = {
  token: string
  children: ReactNode
}

type RecipeErrorBoundaryState = {
  hasError: boolean
}

// Decisão 62 (nota [CC][F-carrinho-wa-novo-padrao]): o app não tem NENHUM
// Error Boundary (risco 116) — uma exceção de render em qualquer tela
// derruba a árvore inteira. Este é local só às telas de receita, contenção
// de escopo até a decisão de design (do humano) para o resto do app.
export class RecipeErrorBoundary extends Component<RecipeErrorBoundaryProps, RecipeErrorBoundaryState> {
  constructor(props: RecipeErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): RecipeErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Só mensagem/stack do erro e do componente — nunca props/state (dado de paciente).
    console.error('RecipeErrorBoundary:', error.message, errorInfo.componentStack)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="flex w-full max-w-[420px] flex-col items-center gap-4 self-center rounded-2xl border border-gray-100 bg-white px-6 py-8 text-center shadow-sm">
        <h1 className="text-lg font-semibold text-gray-950">Algo deu errado</h1>
        <p className="text-sm text-gray-500">
          Não conseguimos carregar esta página agora. Tente novamente ou fale com a nossa ajuda.
        </p>
        <a
          href={`/receitas/${this.props.token}/ajuda`}
          className="w-full rounded-lg bg-primary-800 px-4 py-3 text-sm font-semibold text-white hover:bg-primary-900">
          Falar com a ajuda
        </a>
      </div>
    )
  }
}
